import { useContext, useRef } from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { ProfileContext } from 'context';
import * as constants from '../constants';
export const useCustomRanges = ()=>{
    const profileContext = useContext(ProfileContext);
    const phiSet = useSelector(profileContext.selectors.phiSet);
    // anti-leak safeguard
    const defaultCustomRanges = useRef(constants.HOURS_BREAKPOINTS.map((hb)=>[
            ...hb
        ]));
    return get(phiSet, 'customRanges') || defaultCustomRanges.current;
};
